import Confirmation from "modals/ConfirmationModal/Confirmation";
import InstallPopup from "modals/InstallPopup/InstallPopup";
import LeadCaptureModal from "modals/LeadCaptureModal/LeadCaptureModal";
import React from "react";

const ModalWrapper: React.FC = () => {
  const modals: React.FC[] = [InstallPopup, Confirmation, LeadCaptureModal];
  return (
    <>
      {modals.map((Modal, id) => (
        <Modal key={id} />
      ))}
    </>
  );
};

export default ModalWrapper;
